module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--1--create-25818ebf.jpg";